import { render, staticRenderFns } from "./Nomurakougei1View.vue?vue&type=template&id=2994e3c2&scoped=true&"
import script from "./Nomurakougei1View.vue?vue&type=script&lang=js&"
export * from "./Nomurakougei1View.vue?vue&type=script&lang=js&"
import style0 from "./Nomurakougei1View.vue?vue&type=style&index=0&id=2994e3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994e3c2",
  null
  
)

export default component.exports